import React from "react";
import { observer } from "mobx-react-lite";

import "./SewerObjectsMapLegend.scss";
import { translationService } from "../../services/translation/TranslationService";
import { ReactComponent as MapNode } from "../../icons/map-node.svg";
import { ReactComponent as MapStructure } from "../../icons/map-structure.svg";
import Svg from "../svg/Svg";

export default observer(() => {
  return (
    <div className="map-legend-container">
      <h3>{translationService.translate("Map.legend")}</h3>
      <div className="map-legend-content-container">
        <div className="icons-info-container">
          <div className="icon-info-details">
            <Svg svg={MapNode} />
            {translationService.translate("general.node")}
          </div>
          <div className="icon-info-details">
            <Svg svg={MapStructure} />
            {translationService.translate("general.structure")}
          </div>
          <div className="icon-info-details">
            <span className="section-line" />
            {translationService.translate("general.section")}
          </div>
        </div>
      </div>
    </div>
  );
});
